document.querySelectorAll(".pause-video").forEach(function(e){e.addEventListener("click",function(){let e=this.closest(".video-custom-wrapper").querySelector("video");e&&(e.pause(),this.style.display="none",this.closest(".video-custom-wrapper").querySelector(".play-video").style.display="block")})}),document.querySelectorAll(".play-video").forEach(function(e){e.addEventListener("click",function(){let e=this.closest(".video-custom-wrapper").querySelector("video");e&&(document.querySelectorAll("video").forEach(function(e){e.pause()}),document.querySelectorAll(".play-video").forEach(function(e){e.style.display="block"}),document.querySelectorAll(".pause-video").forEach(function(e){e.style.display="none"}),e.play(),this.style.display="none",this.closest(".video-custom-wrapper").querySelector(".pause-video").style.display="block")})}),document.querySelectorAll(".make-audible").forEach(function(e){e.addEventListener("click",function(){let e=this.closest(".video-custom-wrapper").querySelector("video");e&&(document.querySelectorAll("video").muted=!0,e.muted=!1,e.volume=1,this.style.display="none",this.closest(".video-custom-wrapper").querySelector(".make-mute").style.display="block")})}),document.querySelectorAll(".make-mute").forEach(function(e){e.addEventListener("click",function(){let e=this.closest(".video-custom-wrapper").querySelector("video");e&&(e.muted=!0,this.style.display="none",this.closest(".video-custom-wrapper").querySelector(".make-audible").style.display="block")})});

document.querySelectorAll(".make-audible").forEach(function (e) {
    e.addEventListener("click", function () {
        const video = this.closest(".home-video").querySelector("video");
        if (video) {
            // Mute all videos
            document.querySelectorAll("video").forEach((v) => (v.muted = true));
            
            // Unmute the current video
            video.muted = false;
            video.volume = 1;
            
            // Toggle button visibility
            this.style.display = "none";
            this.closest(".volume-buttons").querySelector(".make-mute").style.display = "block";
        }
    });
});


document.querySelectorAll(".make-mute").forEach(function (e) {
    e.addEventListener("click", function () {
        const video = this.closest(".home-video").querySelector("video");
        if (video) {
            // Mute the current video
            video.muted = true;
            
            // Toggle button visibility
            this.style.display = "none";
            this.closest(".volume-buttons").querySelector(".make-audible").style.display = "block";
        }
    });
});

 document.querySelector('.btn-buy-now').addEventListener('click', function(e) {
                      e.preventDefault(); // Default form submit roko
                      fetch('/cart/add', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                        body: `id={{ product.first_available_variant.id }}`
                      }).then(() => {
                        window.location.href = '/checkout'; // Checkout page pe redirect
                      });
                    });
$(document).ready(function(){
   if ($(window).width() < 750)
    {
  $('.responsive').slick({
  dots: true,
  infinite: true,
  speed: 300,
    autoplay: true,
  slidesToShow: 1,
  slidesToScroll: 1,
    arrows:false,
     prevArrow:"<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/0774/7511/9390/files/left.png?v=1711620681'>",
      nextArrow:"<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/0774/7511/9390/files/right.png?v=1711620675'>",
 responsive: [
  
   
  ]
});
       {
  $('.how-to-used').slick({
  dots: false,
  infinite: false,
  speed: 400,
  autoplay: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows:false,
     prevArrow:"<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/0774/7511/9390/files/left.png?v=1711620681'>",
      nextArrow:"<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/0774/7511/9390/files/right.png?v=1711620675'>",
 responsive: [ 
  {
      breakpoint: 749,
      settings: { 
        slidesToShow: 1.3,
        slidesToScroll: 1
      }
    }
   
  ]
});
      }
      }
  $('.review-slider').slick({
  dots: true,
  infinite: false,
  speed: 400,
  slidesToShow: 5,
 arrows: true,
prevArrow: `<div class="prevArrow-arrow"><svg class="prevArrow" xmlns="http://www.w3.org/2000/svg" width="10" height="18" viewBox="0 0 10 18" fill="none"><path d="M7.797 16.664L0.648 9.20405C0.474552 9.01031 0.377517 8.76007 0.375 8.50005C0.375 8.30505 0.453 8.07005 0.609 7.87505L7.758 0.415048C7.84204 0.324341 7.94328 0.251263 8.05584 0.200072C8.1684 0.148881 8.29002 0.1206 8.41362 0.116878C8.53722 0.113155 8.66032 0.134064 8.77576 0.178388C8.89119 0.222711 8.99666 0.289563 9.086 0.375048C9.476 0.727048 9.476 1.31305 9.125 1.70305L2.602 8.50005L9.164 15.375C9.24955 15.4643 9.31647 15.5697 9.36088 15.6851C9.40529 15.8005 9.42629 15.9236 9.42266 16.0472C9.41903 16.1708 9.39084 16.2925 9.33974 16.405C9.28864 16.5176 9.21564 16.6189 9.125 16.703C9.03572 16.7886 8.93031 16.8555 8.81491 16.8999C8.69951 16.9443 8.57643 16.9653 8.45283 16.9617C8.32924 16.9581 8.2076 16.9299 8.095 16.8788C7.98241 16.8277 7.8811 16.7547 7.797 16.664Z" fill="#090A0B"/></svg></div>`,
nextArrow: `<div class="nextArrow-arrow"><svg class="nextArrow" width="10" height="19" viewBox="0 0 10 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.203 1.42561L9.352 8.88561C9.52545 9.07936 9.62248 9.32959 9.625 9.58961C9.625 9.78461 9.547 10.0196 9.391 10.2146L2.242 17.6746C2.15796 17.7653 2.05672 17.8384 1.94416 17.8896C1.8316 17.9408 1.70998 17.9691 1.58638 17.9728C1.46278 17.9765 1.33968 17.9556 1.22424 17.9113C1.10881 17.8669 1.00334 17.8001 0.914 17.7146C0.523999 17.3626 0.524 16.7766 0.875 16.3866L7.398 9.58961L0.836 2.71461C0.750453 2.62533 0.683525 2.51992 0.639117 2.40452C0.594709 2.28912 0.573709 2.16604 0.577338 2.04244C0.580968 1.91885 0.609156 1.79721 0.660259 1.68461C0.711363 1.57202 0.78436 1.47072 0.875 1.38661C0.964279 1.30107 1.06969 1.23414 1.18509 1.18973C1.30049 1.14532 1.42357 1.12432 1.54717 1.12795C1.67076 1.13158 1.7924 1.15977 1.905 1.21087C2.01759 1.26198 2.1189 1.33497 2.203 1.42561Z" fill="#090A0B"/></svg></div>`,
slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    
    {
      breakpoint: 749,
      settings: {
        slidesToShow: 1.3,
        slidesToScroll: 1
      }
    }
    
  ]
});
  $('.slider-for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '.slider-nav'
});
$('.slider-nav').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  asNavFor: '.slider-for',
  dots: false,
  focusOnSelect: true
});
  
})

    $(".jdgm-prev-badge__text").click(function() {
        window.location.href = "https://www.dentistsity.com/products/teeth-whitening-strips#shopify-section-template--23987944587598__17338227835bdf1713";
    });
